var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscoverLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6C0.5 2.96243 2.96243 0.5 6 0.5H54C57.0376 0.5 59.5 2.96243 59.5 6V34C59.5 37.0376 57.0376 39.5 54 39.5H6C2.96244 39.5 0.5 37.0376 0.5 34V6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6C0.5 2.96243 2.96243 0.5 6 0.5H54C57.0376 0.5 59.5 2.96243 59.5 6V34C59.5 37.0376 57.0376 39.5 54 39.5H6C2.96244 39.5 0.5 37.0376 0.5 34V6Z",
    stroke: "#f4fdfa"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6845_98755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.123 8.62344H47.8671V31.3794H12.1329L12.123 8.62344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7437 21.2804C47.7437 21.2804 37.9766 28.1675 20.0898 31.2563H47.7437V21.2804Z",
    fill: "#F48120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8671 8.49056H12V31.5116H48V8.48141H47.8671V8.49056ZM47.7441 8.74649C47.7441 9.00243 47.7441 30.9906 47.7441 31.2465C47.4881 31.2465 12.521 31.2465 12.2651 31.2465C12.2651 30.9906 12.2651 9.00243 12.2651 8.74649C12.521 8.74649 47.479 8.74649 47.7441 8.74649Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1453 15.5295H13.6582V20.7404H15.1453C15.9314 20.7404 16.5002 20.5513 17.0023 20.1434C17.5992 19.6506 17.9494 18.9116 17.9494 18.1445C17.9402 16.6004 16.7941 15.5295 15.1453 15.5295ZM16.3392 19.4516C16.0172 19.7356 15.6101 19.8685 14.9463 19.8685H14.6721V16.4204H14.947C15.6009 16.4204 15.9989 16.5343 16.3399 16.8374C16.6908 17.1502 16.8989 17.6333 16.8989 18.1353C16.8982 18.6374 16.6894 19.1394 16.3392 19.4516Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.428 15.5295H18.4141V20.7404H19.428V15.5295Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9084 17.5285C21.3023 17.3014 21.1223 17.1496 21.1223 16.8746C21.1223 16.5428 21.4443 16.2967 21.8802 16.2967C22.1833 16.2967 22.4392 16.4197 22.6952 16.7228L23.226 16.0309C22.7901 15.6519 22.2691 15.4529 21.6911 15.4529C20.7721 15.4529 20.062 16.097 20.062 16.9499C20.062 17.6699 20.3938 18.039 21.3409 18.3807C21.7389 18.5228 21.9379 18.6177 22.042 18.6746C22.2409 18.8075 22.345 18.9967 22.345 19.2146C22.345 19.6407 22.0131 19.9536 21.5589 19.9536C21.0759 19.9536 20.687 19.7075 20.4508 19.2617L19.7969 19.8967C20.2609 20.5885 20.8298 20.8916 21.5969 20.8916C22.6487 20.8916 23.3969 20.1906 23.3969 19.1767C23.4152 18.3336 23.0643 17.9546 21.9084 17.5285Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7285 18.1444C23.7285 19.6794 24.9316 20.8634 26.4756 20.8634C26.9116 20.8634 27.2905 20.7784 27.7448 20.5604V19.3665C27.3377 19.7736 26.9777 19.9346 26.5227 19.9346C25.4997 19.9346 24.7698 19.1956 24.7698 18.1346C24.7698 17.1305 25.518 16.3437 26.4749 16.3437C26.958 16.3437 27.3278 16.5146 27.7441 16.9309V15.7369C27.299 15.5098 26.9291 15.4149 26.4932 15.4149C24.9695 15.4156 23.7285 16.6285 23.7285 18.1444Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8174 19.0346L34.4245 15.5295H33.3164L35.5235 20.8726H36.0734L38.3184 15.5295H37.2195L35.8174 19.0346Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7812 20.7404H41.6612V19.8594H39.7952V18.4574H41.5952V17.5756H39.7952V16.4204H41.6612V15.5295H38.7812V20.7404Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6872 17.0736C45.6872 16.0977 45.0143 15.5387 43.8401 15.5387H42.334V20.7495H43.3479V18.6556H43.4808L44.8828 20.7495H46.1337L44.4947 18.5516C45.2611 18.3905 45.6872 17.8695 45.6872 17.0736ZM43.6411 17.9356H43.3472V16.3536H43.6601C44.295 16.3536 44.636 16.6187 44.636 17.1305C44.636 17.6516 44.295 17.9356 43.6411 17.9356Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8619 20.9295C32.395 20.9295 33.6378 19.6867 33.6378 18.1536C33.6378 16.6205 32.395 15.3777 30.8619 15.3777C29.3288 15.3777 28.0859 16.6205 28.0859 18.1536C28.0859 19.6867 29.3288 20.9295 30.8619 20.9295Z",
    fill: "url(#paint0_linear_6845_98755)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M30.8619 20.9295C32.395 20.9295 33.6378 19.6867 33.6378 18.1536C33.6378 16.6205 32.395 15.3777 30.8619 15.3777C29.3288 15.3777 28.0859 16.6205 28.0859 18.1536C28.0859 19.6867 29.3288 20.9295 30.8619 20.9295Z",
    fill: "url(#paint1_linear_6845_98755)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3325 15.7285C46.3325 15.6336 46.2664 15.5865 46.1616 15.5865H46.0098V16.0414H46.1237V15.8614L46.2566 16.0414H46.3895L46.2376 15.8523C46.2945 15.8424 46.3325 15.7946 46.3325 15.7285ZM46.1427 15.7946H46.1237V15.6716H46.1427C46.1996 15.6716 46.2277 15.6905 46.2277 15.7285C46.2277 15.7756 46.1996 15.7946 46.1427 15.7946Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1812 15.4156C45.9632 15.4156 45.7832 15.5956 45.7832 15.8136C45.7832 16.0316 45.9632 16.2116 46.1812 16.2116C46.3991 16.2116 46.5791 16.0316 46.5791 15.8136C46.5791 15.5956 46.3991 15.4156 46.1812 15.4156ZM46.1812 16.1455C46.0103 16.1455 45.8591 16.0034 45.8591 15.8136C45.8591 15.6336 46.0012 15.4817 46.1812 15.4817C46.352 15.4817 46.4941 15.6336 46.4941 15.8136C46.4941 15.9936 46.352 16.1455 46.1812 16.1455Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6845_98755",
    x1: 32.2807,
    y1: 20.3751,
    x2: 30.3619,
    y2: 17.3709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2502,
    stopColor: "#F79A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5331,
    stopColor: "#F68D20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6196,
    stopColor: "#F58720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7232,
    stopColor: "#F48120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37521"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6845_98755",
    x1: 31.9777,
    y1: 20.3347,
    x2: 29.1734,
    y2: 14.8534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3587,
    stopColor: "#E16F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#D4602C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#D05B2E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6845_98755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 24,
    fill: "white",
    transform: "translate(12 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverLogo);
export default __webpack_public_path__ + "static/media/discover_logo.a7c46615dcd3c05f268efaaf3680c87c.svg";
export { ForwardRef as ReactComponent };